/**
 * Posture analysis user settings — HTTP client (GET/PUT/DELETE).
 */
import type { Settings } from '@/components/posture-analysis/types';
import { apiFetch } from '@/lib/api-client';

interface UpdateResponse {
  success: boolean;
  settings: Settings;
}

export async function fetchPostureSettings(): Promise<Settings> {
  return apiFetch<Settings>('/me/settings/posture-analysis');
}

export async function savePostureSettingsHttp(settings: Settings): Promise<Settings> {
  const response = await apiFetch<UpdateResponse>('/me/settings/posture-analysis', {
    method: 'PUT',
    body: JSON.stringify(settings),
  });
  return response.settings;
}

export async function resetPostureSettingsHttp(): Promise<Settings> {
  const response = await apiFetch<UpdateResponse>('/me/settings/posture-analysis', {
    method: 'DELETE',
  });
  return response.settings;
}
